import { makeBetterEnum } from './betterEnum';

/** Primitive fields map directly to attributes of the footprint */
export const FilterFieldLegacy = makeBetterEnum(
  'businessCategory',
  'businessSubcategory',
  'location',
  'locationCountry',
  'vendor',
  'product',
  'footprintKind',
  'ghgScope',
  'ghgCategoryId',
  'buildingName',
  'electricityType',
  'description'
);

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type FilterFieldLegacy =
  (typeof FilterFieldLegacy)[keyof typeof FilterFieldLegacy];

/**
 * These fields map directly to known attributes of the footprint in the new
 * Measurement Artifacts Interface, in contrast with fields custom to customers.
 * Listed in the same order as the fields in FilterField (but with the new
 * names), with the exception of productMarket - that has been removed.
 */
export const FilterFieldWatershed = makeBetterEnum(
  'categoryId',
  'subcategoryId',
  'location',
  'locationCountry',
  'locationState',
  'locationCity',
  'buildingName',
  'vendor',
  'rawVendor',
  'product',
  'footprintKind',
  'ghgScope',
  'ghgCategoryId',
  'companyId',
  'electricityType',
  'description',
  'inputUnit',
  'isSupplierSpecific'
);

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type FilterFieldWatershed =
  (typeof FilterFieldWatershed)[keyof typeof FilterFieldWatershed];

export const InternalFieldWatershed = makeBetterEnum(
  'internalCategoryId',
  'internalSubcategoryId',
  'internalDescription',
  'internalGhgCategoryId'
);

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type InternalFieldWatershed =
  (typeof InternalFieldWatershed)[keyof typeof InternalFieldWatershed];
